export enum communicationPreferencesTypes {
    'EMAIL' = 'EMAIL',
    'PHONE_NUMBER' = 'PHONE_NUMBER',
    'ADDRESS' = 'ADDRESS',
    'PAPERLESS' = 'PAPERLESS',
    'LANGUAGE' = 'LANGUAGE',
    'NOTICES' = 'NOTICES',
}

export enum communicationPreferencesReviewTypes {
    'EMAIL' = 'emailConfirmationNeeded',
    'PHONE_NUMBER' = 'phoneConfirmationNeeded',
    'ADDRESS' = 'addressConfirmationNeeded',
    'PAPERLESS' = 'paperlessConfirmationNeeded',
    'LANGUAGE' = 'languageConfirmationNeeded',
    'NOTICES' = 'marketCommunConfirmationNeeded',
}

export enum communicationPreferences {
    emailAddress = 'emailAddress',
    phoneNumber = 'phoneNumber',
    phoneVerified = 'phoneVerified',
    mailingAddress = 'mailingAddress',
}